module.exports = __webpack_public_path__ + "static/device02-40541464fd1c4bc367fccb63601afe6f.jpg";